import Vue from '@/system/main';

export default {
	async setStatus(id, value, text = false) {
		const result = await Vue.$gestios.items('facturas').edit({
			id,
			params: {
				FacturaEstado: value
			}
		});

		if (result.ok) {
			if (text) {
				Vue.$message.success(`La factura a cambiado a ${text}`);
			} else {
				Vue.$message.success('Estado de factura cambiado correctamente');
			}
			return true;
		}

		return false;
	},
	async renderPDF(item) {
		const hide = Vue.$message.loading({ content: 'Generando PDF...', key: 'renderInvoicePDF' });
		const upload = await Vue.$lambda.get(`invoice/render/${item._EntityId}`);

		if (upload.ok) {
			Vue.$message.success({ content: 'Documento PDF generado correctamente', key: 'renderInvoicePDF', duration: 2 });

			Vue.$gestios.$cache.items('facturas').edit({ id: item._EntityId, params: upload.data });

			return upload;
		}

		hide();
		Vue.$toast.error(`No se pudo generar el documento. ${upload.message}`);

		return upload;
	}
};
